import { useTranslation } from 'react-i18next'
import type { StaatidOversiktResponse } from './api'
import { formatDager, formatDekningsgrad } from './api'

interface Props {
  data: StaatidOversiktResponse | null
}

export default function KpiCards({ data }: Props) {
  const { t } = useTranslation('staatid')
  if (!data) {
    return (
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {[0, 1, 2, 3].map(i => (
          <div key={i} data-testid="staatid-kpi-skeleton" className="card p-4 animate-pulse h-20 bg-gray-100 dark:bg-dark-border rounded-lg" />
        ))}
      </div>
    )
  }

  const cards = [
    { label: t('kpi.sluttsalg'), value: data.totalt_antall_salg.toLocaleString('nb-NO') },
    { label: t('kpi.dekningsgrad'), value: formatDekningsgrad(data.dekningsgrad) },
    { label: t('kpi.medianStaatid'), value: data.median_dager === null ? '—' : t('common.dager', { n: formatDager(data.median_dager) }) },
    { label: t('kpi.snittStaatid'), value: data.snitt_dager === null ? '—' : t('common.dager', { n: formatDager(data.snitt_dager) }) },
  ]

  return (
    <div data-testid="staatid-kpi-cards" className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
      {cards.map(({ label, value }) => (
        <div key={label} className="card p-4">
          <p className="text-xs text-gray-500 dark:text-gray-400 uppercase tracking-wide">{label}</p>
          <p className="text-2xl font-semibold mt-1">{value}</p>
        </div>
      ))}
    </div>
  )
}
